import React from "react";
import { Provider } from "react-redux";
import { jwtDecode } from "jwt-decode";
import {
	loginSuccess,
	loginFailure,
	setPermissions,
} from "./actions/authActions";
import { render } from "react-dom";
import App from "./components/App";
import store from "./store";
import "./assets/styles/index.scss";
import {
	getCustomer,
	getItemFromLocalStorage,
	getPermissions,
	getReseller,
	getToken,
} from "./utils/local-storage.util";
import {
	setCustomer,
	updateBimifyProgress,
	updateExtractProgress,
} from "./actions";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://daafa8dd6142729f4aa959f55a4d3542@o4509478460915712.ingest.de.sentry.io/4509478461964368",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	environment: window.location.hostname,
	sendDefaultPii: true,
	integrations: [
		Sentry.replayIntegration(),
		Sentry.browserTracingIntegration(),
	],
	beforeSend: (event) => {
		if(window.location.hostname === "app.bimify.com") {
			return event;
		}
		return null;
	},
	tracesSampleRate: 1.0, // This sets the sample rate at 100%. You may want to change it to a lower value in production.

	// Session Replay
	replaysSessionSampleRate: 1.0, // This sets the sample rate at 100%. You may want to change it to a lower value in production.
	// replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	// tracePropagationTargets: ["localhost", /^https:\/\/app\.bimify\.com\/api/],
});

//Check if user is logged in on every page reload
const checkLogin = () => {
	if (getToken()) {
		const bimifyProgress = getItemFromLocalStorage("bimifyProgress")
			? JSON.parse(getItemFromLocalStorage("bimifyProgress"))
			: null;

		const extractProgress = getItemFromLocalStorage("extractProgress")
			? JSON.parse(getItemFromLocalStorage("extractProgress"))
			: null;

		store.dispatch(loginSuccess(jwtDecode(getToken())));
		store.dispatch(setCustomer(getCustomer()));
		store.dispatch(setCustomer(getReseller(), true));
		if (!!getPermissions()) store.dispatch(setPermissions(getPermissions()));

		if (!!bimifyProgress) store.dispatch(updateBimifyProgress(bimifyProgress));

		if (!!extractProgress)
			store.dispatch(updateExtractProgress(extractProgress));
	} else {
		store.dispatch(loginFailure("You are not logged in!"));
	}
};

checkLogin();
const root = document.getElementById("root");

render(
	<Provider store={store}>
		<App />
	</Provider>,
	root
);
